import loop54 from '~/lib/api/loop54';
import { Loop54Types } from '~/lib/data-contract';
import { getUrl } from '~/services/loop54/utils';

export default function getSearchAutocomplete(
    signal: AbortSignal | undefined,
    params: Loop54Types.AutoCompleteRequest,
) {
    return loop54
        .post(getUrl('/autoComplete'), {
            json: params,
            signal,
        })
        .json<Loop54Types.AutoCompleteResponse>();
}
